import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "space-y-3" }
const _hoisted_3 = { class: "grid flex-1 grid-cols-1 gap-3 sm:grid-cols-2" }
const _hoisted_4 = { class: "flex justify-center" }

import { useI18n } from 'vue-i18n';
    import { InputRow, MultiCombobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { Button } from '@/components/ui/button';
    import { Plus } from 'lucide-vue-next';
    import DeleteButton from '@/components/DeleteButton.vue';
    import { useVoucherAssigneeOptions } from '@/composables/useVoucherAssigneeOptions';
    import { computed } from 'vue';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { splitAssigneeIds } from '@/utils/voucherAssignees';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherAdministrateFallbackForm',
  props: {
    form: {}
  },
  setup(__props: any, { expose: __expose }) {

    const { t } = useI18n();
    const selectedCompanyId = computed(() => usePage<SharedData>().props.auth.user.selected_company_id);
    const { assigneeOptions, isLoadingAssigneeOptions, dedupeAssigneeIds, toAssigneeIds } =
        useVoucherAssigneeOptions(selectedCompanyId.value);

    const props = __props;

    const fallbackAssigneeIds = computed({
        get: () => props.form.fallback_assignee_ids ?? [],
        set: (value: string[]) => {
            const deduped = dedupeAssigneeIds(value);
            props.form.fallback_assignee_ids = deduped;
            const { employee_ids, user_ids } = splitAssigneeIds(deduped);
            props.form.fallback_employee_ids = employee_ids;
            props.form.fallback_user_ids = user_ids;
        },
    });

    const addVoucherAssignmentRule = () => {
        props.form.voucher_assignment_rules.push({
            prompt: '',
            employee_ids: [],
            user_ids: [],
            assignee_ids: [],
        });
    };

    const removeVoucherAssignmentRule = (index: number) => {
        props.form.voucher_assignment_rules.splice(index, 1);
    };

    const updateRuleAssignees = (index: number, assigneeIds: string[]) => {
        const rule = props.form.voucher_assignment_rules[index];
        const deduped = dedupeAssigneeIds(assigneeIds);
        rule.assignee_ids = deduped;
        const { employee_ids, user_ids } = splitAssigneeIds(deduped);
        rule.employee_ids = employee_ids;
        rule.user_ids = user_ids;
    };

    __expose({
        addVoucherAssignmentRule,
        toAssigneeIds,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "fallback_assignee_ids",
      label: "vouchers.administrate.fallback"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MultiCombobox), {
          modelValue: fallbackAssigneeIds.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fallbackAssigneeIds).value = $event)),
          placeholder: _unref(t)('vouchers.administrate.fallback'),
          options: _unref(assigneeOptions),
          "label-by": "label",
          "value-by": "id",
          loading: _unref(isLoadingAssigneeOptions)
        }, null, 8, ["modelValue", "placeholder", "options", "loading"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "voucher_assignment_rule_employees",
      label: "vouchers.administrate.voucher_assignment_rule"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.voucher_assignment_rules, (assignmentRule, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex gap-3"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(InputRow), {
                  form: _ctx.form,
                  name: "voucher_assignment_rules.prompt",
                  "error-key": `voucher_assignment_rules.${index}.prompt`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Input), {
                      id: "prompt",
                      modelValue: assignmentRule.prompt,
                      "onUpdate:modelValue": ($event: any) => ((assignmentRule.prompt) = $event),
                      placeholder: 
                                    _unref(t)('vouchers.administrate.voucher_assignment_rules_prompt')
                                
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                  ]),
                  _: 2
                }, 1032, ["form", "error-key"]),
                _createVNode(_unref(InputRow), {
                  form: _ctx.form,
                  name: "voucher_assignment_rules.assignee_ids",
                  "error-key": `voucher_assignment_rules.${index}.employee_ids`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MultiCombobox), {
                      "model-value": assignmentRule.assignee_ids,
                      placeholder: _unref(t)('vouchers.administrate.fallback'),
                      options: _unref(assigneeOptions),
                      "label-by": "label",
                      "value-by": "id",
                      loading: _unref(isLoadingAssigneeOptions),
                      "onUpdate:modelValue": ($event: any) => (updateRuleAssignees(index, $event))
                    }, null, 8, ["model-value", "placeholder", "options", "loading", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1032, ["form", "error-key"])
              ]),
              _createVNode(DeleteButton, {
                onClick: _withModifiers(($event: any) => (removeVoucherAssignmentRule(index)), ["prevent"])
              }, null, 8, ["onClick"])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["form"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Button), {
        variant: "ghost",
        size: "sm",
        onClick: _withModifiers(addVoucherAssignmentRule, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('vouchers.administrate.add_voucher_assignment_rule')) + " ", 1),
          _createVNode(_unref(Plus), { class: "text-accent size-3" })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})